import tree from './baobab'
import * as api from './api';

async function getInstances() {
    const response = await api.request(api.Method.GET, '/instances');
    tree.set('instances', response.payload);
}

async function editInstance(instance: any) {
    await api.request(api.Method.PUT, '/instances/' + instance.id, instance);
    await getInstances();
}

async function createInstance(instance: any) {
    await api.request(api.Method.POST, '/instances', instance);
    await getInstances();
}

async function deleteInstance(instance: any) {
    await api.request(api.Method.DELETE, '/instances/' + instance.id);
    await getInstances();
}

async function checkKubectl() {
    const response = await api.request(api.Method.GET, '/checkkubectl');
    return response.payload;
}

export default {
    getInstances,
    editInstance,
    createInstance,
    deleteInstance,
    checkKubectl
}